import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/public/Header";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between bg-[#0b1a3a] text-white p-12">
        <Logo light />
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-tight">CoworkZen<br />Admin Console</h1>
          <p className="text-slate-400 mt-4 max-w-sm">Manage your website content, locations, workspaces, media, and the complete SEO / AEO architecture from one place.</p>
        </div>
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} CoworkZen</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="w-12 h-12 rounded-xl bg-sky-100 text-primary flex items-center justify-center mb-5"><Lock className="w-6 h-6" /></div>
          <h2 className="font-display text-2xl font-bold text-slate-900">Sign in to Admin</h2>
          <p className="text-sm text-slate-500 mt-1 mb-6">Use your CoworkZen administrator account.</p>
          <label className="text-sm font-medium text-slate-700">Email</label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@coworkzen.in" className="mt-1.5 mb-4 h-11" />
          <label className="text-sm font-medium text-slate-700">Password</label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1.5 mb-6 h-11" />
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full h-11 rounded-full gap-2">
            {busy ? "Signing in..." : <>Sign In <ArrowRight className="w-4 h-4" /></>}
          </Button>
        </form>
      </div>
    </div>
  );
}
